import React from 'react';
import { Mail, MessageSquare, Send, Calendar } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";
import ContactForm from "./contact/ContactForm";
import SituationImage from "./situation/SituationImage";
import { useImageFetcher } from "./situation/useImageFetcher";
import { useIsMobile } from "@/hooks/use-mobile";

const NextSteps = () => {
  const isMobile = useIsMobile();
  const { getBackgroundImage } = useImageFetcher({ 
    section: "next-steps" 
  });
  const fallbackImageUrl = 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&q=80';
  const backgroundImage = getBackgroundImage(fallbackImageUrl);

  return (
    <div id="next-steps" className="bg-gradient-to-r from-[#243949] to-[#517fa4]">
      <div className="container mx-auto px-4 py-6 md:py-12">
        <h2 className="text-xl md:text-2xl text-white font-bold text-center mb-6 uppercase">
          Kontakt & Next Steps
        </h2>
        
        {isMobile ? (
          <div className="flex flex-col md:flex-row md:items-center md:space-x-8">
            <SituationImage imageUrl={backgroundImage} isMobile={true} section="next-steps" />
            <div className="w-full md:w-1/2">
              <ContactOptions />
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center">
            <SituationImage imageUrl={backgroundImage} isMobile={false} section="next-steps" />
            <div className="w-full mt-8">
              <ContactOptions />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// Helper component to separate contact options
const ContactOptions = () => {
  const SHOW_FORM_AND_BOOKING = false; // Temporary: hide first two boxes
  return (
    <div className="grid grid-cols-1 gap-6">
      {SHOW_FORM_AND_BOOKING && (
        <>
          <Link 
            to="/contact"
            className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6 cursor-pointer transition-all hover:bg-white/20"
          >
            <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
                <Send className="w-6 h-6 text-white" />
              </div>
            </div>
            <div>
              <h3 className="text-base md:text-lg text-white pl-4 text-left">
                Kontaktformular
              </h3>
              <p className="text-base md:text-lg text-white pl-4 text-left">
                Schreibe mir eine Nachricht über das Kontaktformular - ich melde mich in &lt;24h bei dir.
              </p>
            </div>
          </Link>

          <Link 
            to="/booking"
            className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6 cursor-pointer transition-all hover:bg-white/20"
          >
            <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
                <Calendar className="w-6 h-6 text-white" />
              </div>
            </div>
            <div>
              <h3 className="text-base md:text-lg text-white pl-4 text-left">
                Kennenlerngespräch buchen
              </h3>
              <p className="text-base md:text-lg text-white pl-4 text-left">
                Buche direkt einen Termin für ein unverbindliches 20min-Gespräch.
              </p>
            </div>
          </Link>
        </>
      )}

      <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6">
        <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
            <Mail className="w-6 h-6 text-white" />
          </div>
        </div>
        <div>
          <h3 className="text-base md:text-lg text-white pl-4 text-left mb-6">
            Direkte Kontaktaufnahme
          </h3>
          <div className="flex flex-col gap-2 pl-4">
            <a 
              href="mailto:torstenresack@gmail.com"
              className="flex items-center gap-3 text-white hover:text-blue-200 transition-colors duration-300"
            >
              <Mail className="w-4 h-4" />
              torstenresack@gmail.com
            </a>
            <a 
              href="https://wa.me/4915738099275"
              className="flex items-center gap-3 text-white hover:text-green-200 transition-colors duration-300"
            >
              <MessageSquare className="w-4 h-4" />
              +49 (0)1573 80 99 275
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextSteps;
